import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/45b021a8/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Typography`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`0.875rem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plex 14`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Widget title, link, header, body text size`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`0.75rem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plex 12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Empty / no permission / error text size`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Spacing`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Token`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Role`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`\$spacing-lg`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`24`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List line spacing, widget padding`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`\$spacing-md`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`All other spacing between elements`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Color`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Carbon variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Role`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ui-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Background color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`#ffffff`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Title, header, and text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`#152935`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$brand-01`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Link color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`#3d70b2`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-02`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Empty / no permission / error text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`#5A6872`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bottom border of widget title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`#F0F3F6`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Specs`}</h2>
    <h3>{`Padding`}</h3>
    <p>{`The widget padding should be 1.5rem (24px) for the top, left, right, and bottom of the content area. All widgets should have the same padding, regardless of size.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.73601147776183%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQ4y42U227CMBBE+f9P61tVlaq0BcJNhZAm8WXtBJPpOFwUJaXwMNrYXh92dyxGxh1wkZYaRg6w7qS4bvd6Obab3zmLGpneYYy70iJVAusD98IVrM+5Gc9+tBvcGwDbC7bGsjBY5wpKWSgt8P4AX7Fq5gj1TeCGQOfDoIsBUEyFmavxVpbYpCk2RQE5HuEBZARnludVwLQO/DH/d4XdlhyBY+vxxO93Xp4QkhA4DwFJOGLF7xfq2Trscg11r2VhywmBk8xisVZYbnXbMpoGDYEgLI9w7rl4r2fOqD9Ym1vMCFwaA12U0MYS0pyAzSnmDHO2LR2jBi1f415jLhU+aMp2myFldPEyTYnR+QqJc5hyzk5ihQ+0HIGr6KA57aWFYF+6VnkpWBI68/W5wjumiPFICFwz0dJFRZNygmq6eowzZCzY8oLx5gy7FUaXPzjDBZ+JcF7qLMN1VHw+K+qdFSq+xQdcrjAl8JUVzOoDvlqFNn5SU85yzPXE3Hk2rS7QqOh4T9KJ0v8PuNWy6czzX13yehX+AhOPPJHvoRyJAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Small Widget Normal State",
        "title": "Small Widget Normal State",
        "src": "/static/ed5c27a2b1d0f5b9f30270661fbd575e/3f968/normal_state_small.png",
        "srcSet": ["/static/ed5c27a2b1d0f5b9f30270661fbd575e/7fc1e/normal_state_small.png 288w", "/static/ed5c27a2b1d0f5b9f30270661fbd575e/a5df1/normal_state_small.png 576w", "/static/ed5c27a2b1d0f5b9f30270661fbd575e/3f968/normal_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Lists`}</h3>
    <p>{`You can style lists with or without rulers separating the rows. In both cases, spacing between the rows should be 32 pixels.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "834px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "97.4820143884892%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAAsSAAALEgHS3X78AAAB4ElEQVQ4y5VU2W7bMBD0//9bXooCQVMkqdM0aRNbskiKh0hqOkudNpTWITBY6tjhHrPcaRthXAfdOrgQ4btU4EIq71s/frcdbZztR9gJofUdVKOQYwJyLpB92waEIN/jVWQjYQdLp98+4dEE7NsOD9oXPJPIkrzSDieSXxnhQHhPh68kvKW9Z7oPTHufe2jivWlRGXc9odROk6w6OTTKo09Me1w9I5Q6tp9JWQiL84S+RyZkn0j4yaYshFsrM+WBcGnMFs5ryJQyI0kj8goxDfK5jEQOmA5ZDuywm06VGhX4j6PYimh4Xkh3ejyhbsyMtcC3IN8V1dAQi/BpST4LW2sNNUJSxXmbLgD4mOFJHOJK9APh0BR5WZuOP+TS5ZSHTl8iEZEkPYM4qncoV7FUeS7DQCh1Mx71yUJRh2X86LiFTI2qo4J/fYMxJwZjmGGeo5wn5bvllLAWd9w/0mlP50s8EXecopuDwreqwRd7wJP+xUgDjtqd6/CFBf7BaflJeyBhTeeKqLdAKWneI8++xpv9wwYlNDYshH4S9pTavxZrm1jnnHp09HNhuuJWKUuEMhGlEaPdgjQl8ForuvXSRErHhFm7RdhFh+PDdYjzZSETtpCNEQqZXo3S/7E9NZP9Cw5oyeHzCIC5AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Widget List",
        "title": "Widget List",
        "src": "/static/691cd5d401cea0ac02eed504665daf18/4ff8c/list_widget.png",
        "srcSet": ["/static/691cd5d401cea0ac02eed504665daf18/7fc1e/list_widget.png 288w", "/static/691cd5d401cea0ac02eed504665daf18/a5df1/list_widget.png 576w", "/static/691cd5d401cea0ac02eed504665daf18/4ff8c/list_widget.png 834w"],
        "sizes": "(max-width: 834px) 100vw, 834px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`States`}</h2>
    <p>{`Widgets have five distinct states, each with their own styling: `}<b>{`normal, empty, permission, error,`}</b>{` and `}<b>{`loading`}</b>{`.`}</p>
    <ul>
      <li parentName="ul">{`In the normal state, text is left-aligned except for calls to action`}</li>
      <li parentName="ul">{`In every other state, content is center-aligned with an illustration and small, grey text`}</li>
    </ul>
    <h3>{`Normal state`}</h3>
    <p>{`The normal state is the primary state. It occurs when a widget has been populated with data that the user has permission to see.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.73601147776183%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQ4y42U227CMBBE+f9P61tVlaq0BcJNhZAm8WXtBJPpOFwUJaXwMNrYXh92dyxGxh1wkZYaRg6w7qS4bvd6Obab3zmLGpneYYy70iJVAusD98IVrM+5Gc9+tBvcGwDbC7bGsjBY5wpKWSgt8P4AX7Fq5gj1TeCGQOfDoIsBUEyFmavxVpbYpCk2RQE5HuEBZARnludVwLQO/DH/d4XdlhyBY+vxxO93Xp4QkhA4DwFJOGLF7xfq2Trscg11r2VhywmBk8xisVZYbnXbMpoGDYEgLI9w7rl4r2fOqD9Ym1vMCFwaA12U0MYS0pyAzSnmDHO2LR2jBi1f415jLhU+aMp2myFldPEyTYnR+QqJc5hyzk5ihQ+0HIGr6KA57aWFYF+6VnkpWBI68/W5wjumiPFICFwz0dJFRZNygmq6eowzZCzY8oLx5gy7FUaXPzjDBZ+JcF7qLMN1VHw+K+qdFSq+xQdcrjAl8JUVzOoDvlqFNn5SU85yzPXE3Hk2rS7QqOh4T9KJ0v8PuNWy6czzX13yehX+AhOPPJHvoRyJAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Normal State",
        "title": "Normal State",
        "src": "/static/ed5c27a2b1d0f5b9f30270661fbd575e/3f968/normal_state_small.png",
        "srcSet": ["/static/ed5c27a2b1d0f5b9f30270661fbd575e/7fc1e/normal_state_small.png 288w", "/static/ed5c27a2b1d0f5b9f30270661fbd575e/a5df1/normal_state_small.png 576w", "/static/ed5c27a2b1d0f5b9f30270661fbd575e/3f968/normal_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Empty state`}</h3>
    <p>{`The empty state occurs when the user has no data to populate the widget.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.59253945480631%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABe0lEQVQ4y41Ti3KCMBD0//+uOnUcW5+IM/KQkEASAnW7oeC0gFVmdi7cY7OXS2aFqdFDadfa0jTEz3/vG+fUo5jHbJjobZSXiKVGaRv6mjux6nJTZZAyPqwbEbYFukYgS4SZhKSVSsPaGraiKuZo4kLfmdC2GXUx+9MOYRjc119YZgKnKEZ4zWBuN1gAVxInRYVd1WDrGm5mnyu0tEuqmZMgJI7Ep3PYuKpdn3DDgvattIgyBfmIsFfoWzqQMKcqeJDgSqWb/QWOyvznY0cqrHzLg+FMtvxBwgOJSl9MnFWBdayQ8Ch0p3plKghp7oTTCjkQY0jIyc5Dx8EIHEWOgDgJgSDn+ppjEdZYlQ4ZJ/0/Ydfynq2lbEeLAlEskKYSSZJznUNTVcoND8yxbY2bvoejM8Tjz8c8oelqXjrDgEWG56hoiw6q9flJA2vreG3Ma1PesY13V2NHbAbYEktOeF2Y59em6O5i/yJ+26FPT7zvSYU96VP073ug8Bt91DzECP045wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Empty State",
        "title": "Empty State",
        "src": "/static/0e6b500872dc041d0b834e8f1621860e/3f968/empty_state_small.png",
        "srcSet": ["/static/0e6b500872dc041d0b834e8f1621860e/7fc1e/empty_state_small.png 288w", "/static/0e6b500872dc041d0b834e8f1621860e/a5df1/empty_state_small.png 576w", "/static/0e6b500872dc041d0b834e8f1621860e/3f968/empty_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Permission state`}</h3>
    <p>{`This state occurs when a user does not have permission to see the widget data. For example a user may not have permission to manage other users or view usage data.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.59253945480631%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABeElEQVQ4y41UiXKCMBT0//+udWo7tvXgsB1QgUAuiG43FBwLWM3MzsMkb7PLBmeVbtCjVHVbpXbE7+9+7nqPHOy/xmxI5mtSSKRCQRrHOXchLru9B64dSz3qGxG2DapBKCTiTECwilLBmAbGUjn3KOKbhDsSauNGLmZ/7BCai5vmhEWWI0pSxMcM+nyGBXAk8b6yWFuHVe14mLmv0LAuqOaZBDEREB91Q9TY8jnCGXPWJ2mQZCXELcJeobe0JWFBVfDgOCR7hJsQJxL74dcCKrTe8iCcScvvJPRqpG8mvqRCkAscGgfVqX7TFrnQF8JphQxEaxIy2ee4ZjA5tkSQFYiKoiWNaHO+c3iVFhnD+Z/wYtkhZXVUJooKaVq0qJh4oywSHuwtm7annr6Ho3eI28Ov+UN11/PQOwzZpJloSVR89ijbOZ80sDQ1r41+LOU1bbww0TXxOcCKWNDustL3r03V3cX+i7iuwzk18R8wqbAnvYv++x4o/AEQOT0NDgEm9wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Permission State",
        "title": "Permission State",
        "src": "/static/6425d63557bcfdfda25bd470f80ebae9/3f968/permission_state_small.png",
        "srcSet": ["/static/6425d63557bcfdfda25bd470f80ebae9/7fc1e/permission_state_small.png 288w", "/static/6425d63557bcfdfda25bd470f80ebae9/a5df1/permission_state_small.png 576w", "/static/6425d63557bcfdfda25bd470f80ebae9/3f968/permission_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Error state`}</h3>
    <p>{`The error state occurs when data fails to load.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.59253945480631%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABgElEQVQ4y41Ti1KDMBDs/3+c46tVa+XRF9NWSgiPhEBZNwidCigys3PJXW7Zy11mqSrRIclNYzNVEd/7zjc8Uw5iFrP+QWuPcYaTzJHpir7qSpy0Z8NEIWS8nzcgbBLyEhuZYRdJSFqZ5NC6hC6oimdy4kDfnsh1Nahi9qMcQjHolRcsIoHt8YTdOUJe1ygAnLXBZ1rALSo4puLP9LRCTbugmkcS7Ig14ZQVVpcaPtdbkj/RPmQaxyiB/I2wU2hL8kkYMxEW/Pb7AOu7e0CIZm9jayosbMm95oyWvCKhjxop+SQJPCHhej5EmiFtVNd4VQWEVFfCcYVsiFIGS3b2OSgRiBjOKcTmLOBz7UUxDnGCeVDhJSsQsdN/E7Yle+xqqCnPGKiMXb4BeJ825rMxuskx43M4uEP8/tmYJVRtzuQdvpNwwyRFJPYuW9i19W2JN46Q5ID/q8suy5ibEi7x0YNDLNjhZaqmxyZtZ7F7Ebe278tH3veowo50Et377in8AnhgPPAY+sylAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Permission State",
        "title": "Permission State",
        "src": "/static/4ea3d8c58d34d30e2e6a62ee54831605/3f968/error_state_small.png",
        "srcSet": ["/static/4ea3d8c58d34d30e2e6a62ee54831605/7fc1e/error_state_small.png 288w", "/static/4ea3d8c58d34d30e2e6a62ee54831605/a5df1/error_state_small.png 576w", "/static/4ea3d8c58d34d30e2e6a62ee54831605/3f968/error_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Loading state`}</h3>
    <p>{`The loading state appears while the widget data loads. Static headers are displayed as text and loading content is replaced by skeletons.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.59253945480631%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAABdElEQVQ4y5WTbW+DIBSF9/9/3bYPXZa11nY162a0oryIb2cHCkljM+3aHEG4PBzuxSdpekQ1uvOtageo8B7H7mJu+rd6mge69kco5LX2YElFcOM361E2BgXn5+vugH4B22Ot8FlWqIWEYL8lxNrBz2nV4UxY1miYm83uHHooZTi570dsqgqnPEd2qaCmEQZAQXChLBLCd7aHoNN6zWHLdsPg5xE4Ugm15QbbjpBhREq9TBNedYv80vwNjA41Jw4EnjT7imNULS3VQVCyscgYd+QGbVizcOTOA1MC07pGVV4IknC/ia7cnz2UfLoYHU616jBljhIWpCgEikrC8F07AGWZx3M/+JgIXCxKdHhiBbVhFamalXW5Em4h+xmh/3LocvjlCqSuKdBuPMjy/ZvuHszh9dp8EHhgnhTzJmZyY0fOvbcdKt7Hh6qcmuvV2VPuviVBuzD2RndbaZAzv4tAGXLioM6pXlL4nuXakSN0VfH7njn8BTI6PYnRZAL5AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Permission State",
        "title": "Permission State",
        "src": "/static/2547885423e00e450eb6eada6325438f/3f968/loading_state_small.png",
        "srcSet": ["/static/2547885423e00e450eb6eada6325438f/7fc1e/loading_state_small.png 288w", "/static/2547885423e00e450eb6eada6325438f/a5df1/loading_state_small.png 576w", "/static/2547885423e00e450eb6eada6325438f/3f968/loading_state_small.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Content`}</h2>
    <h3>{`Widget tiles`}</h3>
    <p>{`Each widget has a tile that can be seen when users open the “Add widget” side panel during dashboard customization. Each tile features the `}<b>{`widget icon`}</b>{`, `}<b>{`widget title`}</b>{`, and `}<b>{`short description`}</b>{` (max characters: 35).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "908px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "55.396475770925115%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAAA0klEQVQoz6WSC27DIBBEc//z5Q5RG7fY4bu7wHRMYymNZFVxkIaPYB+zLKeYFY8KSf6Mqzzn4UnPZzad9mC5KFIuHAW1dZjVIVUbe3vQXaAw0M03fLllzK02tDu4yK/rl4FZDLeQ4JZAV+uaDq2NPR9fBBbClK62N4yZqdeK3vtRoMJaw/V7weT8cFpE3gEaGA122NoKOwwUAp0JPueAy+Qx+8QK63spV7ryISKlzAt0pNza0aIwqMWIzsI8tmMOebgQpOczrpcJHy6i8IOr2b/AH4JvWarOfN3iAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Widget Tile",
        "title": "Widget Tile",
        "src": "/static/5168ea84b91d6d13d7e9c8545825a4d9/013af/widget_tile.png",
        "srcSet": ["/static/5168ea84b91d6d13d7e9c8545825a4d9/7fc1e/widget_tile.png 288w", "/static/5168ea84b91d6d13d7e9c8545825a4d9/a5df1/widget_tile.png 576w", "/static/5168ea84b91d6d13d7e9c8545825a4d9/013af/widget_tile.png 908w"],
        "sizes": "(max-width: 908px) 100vw, 908px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Illustrations`}</h3>
    <p>{`All dashboard illustrations should be 72x72px and should match the illustration style of these `}<a parentName="p" {...{
        "href": "https://ibm.box.com/s/f2efq7ylbuwlfwnpwdqzk45c6mkz17bc"
      }}>{`sample dashboard illustrations`}</a>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.12769010043042%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/ElEQVQ4y52TAW7DIAxFe/9TTlMXZZ2adAUMAcOfgZJ0Wtc0sfRlQ8zDJnDQNiBLkXjyUCX2q9JzXl3fdFgGSxI5hp0iaGKY27fsyVXlcYPq5v8CK8wKZBgveD926D5PsM4hm50ChqvDqBwmz7UbWgr5F5grYGb4EBACI8aElKIgk8zHMg7i5wrXgEaA96a1kWp7XI2b53grMKU0LyZj8PZxRj/YfUC6AfPZWWdhiKCUgiuxlfPzpe1tLQtw/FY49md0p0E01vjrIhvuALaWWRY2eU4Cqi2HPS0/M45bfor4GOv1eKS8WZBrtQq8f076Bf3Kf1Zh8S/oESzrB5I69j3HiJ15AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Dashboard Illustration",
        "title": "Dashboard Illustration",
        "src": "/static/be3bc0a967b061efdb9579e61feb3a8e/3f968/small_empty_plain.png",
        "srcSet": ["/static/be3bc0a967b061efdb9579e61feb3a8e/7fc1e/small_empty_plain.png 288w", "/static/be3bc0a967b061efdb9579e61feb3a8e/a5df1/small_empty_plain.png 576w", "/static/be3bc0a967b061efdb9579e61feb3a8e/3f968/small_empty_plain.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h3>{`Icons`}</h3>
    <p>{`Use the `}<a parentName="p" {...{
        "href": "/guidelines/iconography/library"
      }}>{`Carbon icon library`}</a>{` for icons within the widget itself.`}</p>
    <h2>{`Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ibm.box.com/s/13qdd7bgbhg7fv9xfty7g3ho9wtkwxdh"
        }}>{`Widget Sticker Sheet`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ibm.box.com/s/f2efq7ylbuwlfwnpwdqzk45c6mkz17bc"
        }}>{`Sample Dashboard Illustrations`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://cloud.ibm.com/docs/service-framework?topic=service-framework-user-experience-ux-#ux015-dashboard-widgets"
        }}>{`Service Framework`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://test.cloud.ibm.com/docs/developing/get-coding/console-sdk?topic=onboarding-step1-build"
        }}>{`Developer Guidelines`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      